<!-- Mesmo layout da Visão geral (card 3418): cadastro à esquerda, coluna lateral de cards à direita. -->
<div class="kyc" role="tabpanel">
  @if (company(); as registryCompany) {
    <div class="kyc__main">
      <app-registry-company-card [empresa]="registryCompany" />
      @if (partners().length) {
        <app-registry-partners-card [socios]="partners()" />
      }
    </div>
  }

  <!-- Coluna lateral: consentimento e acesso do cliente (card 3461); os próximos cards do KYC entram aqui. -->
  @if (signedTerm() || (canInviteClient() && dealId())) {
    <aside class="kyc__aside">
      @if (signedTerm()) {
        <app-deal-consent-card
          [term]="term()"
          [openingTerm]="openingTerm()"
          (openTerm)="openTerm.emit()" />
      }
      @if (canInviteClient() && dealId(); as id) {
        <app-client-access-card
          [dealId]="id"
          [companyName]="companyName()"
          [rejected]="dealRejected()"
          (invited)="clientInvited.emit()" />
      }
    </aside>
  }
</div>
